import { reactive, toRefs, onMounted, nextTick, ref } from 'vue'
import { useRouter } from 'vue-router'
import Tab from '@/components/order/Tab'
import OrderCard from '@/components/order/OrderCard'
import SubmitOrder from '@/components/order/SubmitOrder.vue'
import UseDealer from '@/components/canUseDealer/CurrentDealer'

import { btnCallBack, reorganizeListData, cancelReason } from '@/util/order/handle'
import { getOrderList, deleteOrder, cancelOrder } from '@/api/order'
import { getContractOrderContent } from '@/util/order/tool'
import { showToast } from '@/util/couponCollection'
import { useStore } from 'vuex'

export default {
  name: 'orderList',
  components: {
    Tab,
    OrderCard,
    SubmitOrder,
    UseDealer
  },
  setup() {
    const router = useRouter()
    const store = useStore()
    const query = router.currentRoute.value.query
    const showSubmitOrderPopUp = ref()
    const useDealerRef = ref()
    const state = reactive({
      statusActive: +query.status,
      query,
      statusTypeTab: [
        { text: '全部', id: 0 },
        { text: '待支付', id: 1 },
        { text: '待完成', id: 2 },
        { text: '已完成', id: 3 },
        { text: '退款/售后', id: 4 }
      ],
      cardData: [], // 展示数据
      searchValue: '',
      isShowDialog: false,
      dialogConfig: {},
      isShowLoad: false,
      isCanLoad: true,
      loadingTxt: '',
      hasFinished: false,
      productPageNo: 1,
      pageSize: 1000,
      cancelReason,
      cancelReasonRes: '',
      applyDealerParam: {}
    })
    const viewUseDealer = data => {
      console.log('viewUseDealer--list', data)
      if (data.sign === 'contractOrder') {
        // 服务合约
        state.applyDealerParam = { ...data }
      } else {
        if (!data?.productId || !data?.gsCode) {
          return
        }
        state.applyDealerParam = { loyaltyId: data.productId, gsCode: data.gsCode, sign: data.sign, orderId: data.orderId }
      }
      nextTick(() => {
        useDealerRef.value.showPop()
      })
    }

    // 设置loading
    const setLoading = (isShowLoad = false, loadingTxt = '') => {
      state.isShowLoad = isShowLoad
      state.loadingTxt = loadingTxt
    }

    // 根据tab状态获取orderStatusFlag
    const getStatusFlagByStatusActive = () => {
      /*
        0全部， orderStatusFlag 0
        1待支付， orderStatusFlag 1
        2待完成， orderStatusFlag 3
        3已完成， orderStatusFlag  6
        4退款/售后，--| orderStatusFlag 组合为  21
      */
      let { statusActive } = state
      //  订单状态{1：待支付 2：已取消（客户取消/超时自动取消） 3：待接单 4：申请退款 5：已拒单 6：已接单，待评价 7：已评价 8：已作废，全部-0}
      const statusFlag = [0, 1, 3, 6, 21]
      return statusFlag[statusActive]
    }
    // 获取请求参数
    const getParams = () => {
      let keyword = (state.searchValue && state.searchValue.trim()) || ''
      let param = {
        pageNo: state.productPageNo,
        pageSize: state.pageSize,
        orderStatusFlag: getStatusFlagByStatusActive()
      }
      keyword && (param.keyword = keyword)
      return param
    }
    // 重置页面参数
    const resetPageParam = () => {
      state.productPageNo = 1
      state.cardData = []
      state.isCanLoad = true
      state.hasFinished = false
      state.dialogConfig = {}
      state.isShowDialog = false
    }
    // 初始化
    const init = async () => {
      if (!state.isCanLoad) return
      state.isCanLoad = false
      setLoading(true)
      let param = getParams()
      try {
        const { list = [], pagination = {} } = await getOrderList(param)
        // 如果已经切换了tab,舍弃当前结果
        if (param.orderStatusFlag !== getStatusFlagByStatusActive()) return
        const tempData = reorganizeListData(list)
        state.isCanLoad = true
        state.hasFinished = pagination.pageNo === pagination.pageCount
        state.productPageNo += pagination.pageNo < pagination.pageCount ? 1 : 0
        state.cardData = state.cardData.concat(tempData)
        nextTick(async () => {
          setLoading()
        })
      } catch (e) {
        if (param.orderStatusFlag !== getStatusFlagByStatusActive()) return
        showToast(e.message, '请求订单列表数据失败', { type: 'html' })
        state.isCanLoad = false
        state.hasFinished = true
        setLoading()
      }
    }
    const toPay = param => {
      showSubmitOrderPopUp.value && showSubmitOrderPopUp.value.chosePayType && showSubmitOrderPopUp.value.chosePayType(param)
    }

    // 点击卡片按钮
    const clickBtn = async v => {
      console.log('clickBtn-->', v)
      if (!v || !v._data) return
      const { orderTypeFlag, orderNo, payAmount, submitTypeFlag, discountGroupId = '' } = v._data
      let param = Object.assign({}, v.param, { orderId: v._data.id, orderTypeFlag })
      // 执行异步回调函数
      if (v.fn) {
        // 取消订单、申请退款、撤销退款、售后、确认完成、激活-需要弹窗确认
        if (['1', '3', '4', '5', '88', '89'].includes(v.btnId)) {
          if (v.btnId === '5') {
            param = { ...param, ...v }
          }
          if (v.btnId === '1') {
            param = { ...param, orderTypeFlag }
          }
          state.dialogConfig = Object.assign(v.dialogConfig, {
            subParam: { v, param }
          })
          state.isShowDialog = true
        } else {
          try {
            setLoading(true, v.text)
            await btnCallBack(v, param)
            resetPageParam()
            nextTick(async () => {
              await init()
            })
          } catch (e) {
            showToast(e.message, '操作失败')
            setLoading()
          }
        }
      }
      // 取消轮胎预约订单单独处理【需要选择原因】
      const canceTyrelOrder = async param => {
        if (Number.isFinite(state.cancelReasonRes)) {
          param.profile = state.cancelReason[state.cancelReasonRes]
          param.orderTypeFlag = orderTypeFlag
          await cancelOrder(param)
        } else {
          throw Error('请选择一个取消原因')
        }
      }
      // 轮胎订单，取消需要弹窗
      if ('1' == v.btnId && orderTypeFlag === 3) {
        // submitTypeFlag":{1：到店订单 2：在线下单
        param.profile = ''
        state.dialogConfig = Object.assign(v.dialogConfig, {
          subParam: { v, param },
          cb: submitTypeFlag === 2 ? canceTyrelOrder : cancelOrder,
          isTyreOrder: submitTypeFlag === 2
        })
        state.cancelReasonRes = ''
        state.isShowDialog = true
      }

      // 服务合约订单，取消组合优惠需要弹窗
      if ('1' == v.btnId && orderTypeFlag === 6) {
        let contractOrderContent = await getContractOrderContent({ discountGroupId, payAmount })
        // console.log('contractOrderContent--', contractOrderContent)
        if (contractOrderContent.isContractOrder && !contractOrderContent.contractOrderList.length) {
          return false
        }
        state.dialogConfig = Object.assign(
          v.dialogConfig,
          {
            subParam: { v, param },
            cb: cancelOrder
          },
          { ...contractOrderContent, title: '组合订单合并取消' }
        )
        state.isShowDialog = true
        return
      }
      // 服务合约订单，支付组合优惠需要弹窗
      if ('2' == v.btnId && orderTypeFlag === 6) {
        let contractOrderContent = await getContractOrderContent({ discountGroupId, payAmount })
        param.orderNo = orderNo
        if (contractOrderContent.isContractOrder) {
          if (!contractOrderContent.contractOrderList.length) {
            return false
          }
          state.dialogConfig = Object.assign(
            {
              confirmButtonText: '确认支付',
              cancelButtonText: '取消'
            },
            {
              subParam: { v, param },
              cb: toPay,
              refresh: false
            },
            { ...contractOrderContent, title: '组合订单合并付款' }
          )
          state.isShowDialog = true
        } else {
          toPay(param)
        }
        return
      }
      // 服务合约订单，组合优惠-合并退款需要弹窗
      if ('3' == v.btnId && orderTypeFlag === 6 && v.customDialog) {
        let contractOrderContent = await getContractOrderContent({ discountGroupId, payAmount })
        param.orderNo = orderNo
        param.orderTypeFlag = orderTypeFlag
        if (contractOrderContent.isContractOrder) {
          if (!contractOrderContent.contractOrderList.length) {
            return false
          }
          v.fn = 'applyRefund'
          state.dialogConfig = Object.assign(
            {
              confirmButtonText: '一起退款',
              cancelButtonText: '取消'
            },
            {
              subParam: { v, param }
            },
            { ...contractOrderContent, title: '组合订单合并退款' }
          )
          state.isShowDialog = true
        }
        return
      }
      // 立即支付
      if ('2' == v.btnId) {
        toPay({ orderNo, orderTypeFlag })
      }
      // 点击评价
      if (['6', '8', '9'].includes(v.btnId)) {
        console.log('跳转到评价页面')
      }
      if (v.btnId === '11') {
        //立即预约
        let { dealer: dealerInfo, carInfo } = v._data
        store.dispatch('setOabInfo', { dealerInfo, carInfo })
        router.push({ path: '/oabCreate', query: { from: 'orderList', orderId: v._data.id } })
      }
      if (v.btnId === '12') {
        //查看预约
        let { oabInfo } = v._data
        router.push({ path: '/oabDetail', query: { from: 'orderList', oabId: oabInfo.reservationId } })
      }
    }

    // 切换订单状态
    const clickStatusType = v => {
      // console.log('clickStatusType', v)
      router.push({
        query: { status: v.id, event: '切换订单状态' }
      })
      state.statusActive = v.id
      state.searchValue = ''
      resetPageParam()
      nextTick(async () => {
        await init()
      })
    }

    // 点击列表卡片内容
    const clickCard = item => {
      // console.log('clickCard-->', item)
      const { orderId, miniMallOrder, orderTypeFlag } = item
      router.push({ path: '/orderDetail', query: { orderId, miniMallOrder, orderTypeFlag, event: '查看订单详情' } })
    }

    // 点击卡片删除按钮
    const clickDelete = async v => {
      // console.log('clickDelete-->', v);
      const param = { orderId: v.id, orderNo: v.orderNo, orderTypeFlag: v.orderTypeFlag }
      state.dialogConfig = Object.assign(
        {
          content: '确定删除订单？',
          confirmButtonText: '确认删除',
          cancelButtonText: '暂不删除'
        },
        { subParam: { v, param }, cb: deleteOrder }
      )
      state.isShowDialog = true
    }

    // 点击搜索
    const onSearch = () => {
      // state.statusActive = 0;
      resetPageParam()
      nextTick(async () => {
        await init()
      })
    }

    // 删除一个卡片
    const hiddenCard = v => {
      state.cardData.splice(v, 1)
    }

    //关闭弹窗
    const beforeCloseDialog = async action => {
      if (action === 'confirm') {
        try {
          const {
            subParam: { v, param },
            cb,
            refresh
          } = state.dialogConfig
          // console.log(state.dialogConfig.subParam,param)
          cb && (await cb(param))
          v.fn && (await btnCallBack(v, param))
          if (refresh === false) {
            return
          }
          resetPageParam()
          nextTick(async () => {
            await init()
          })
          return true
        } catch (e) {
          setLoading()
          showToast(e.message, '操作失败')
        }
      }
      if (action === 'cancel') {
        state.dialogConfig = {}
        state.cancelReasonRes = ''
        return true
      }
    }

    onMounted(() => {
      resetPageParam()
      nextTick(async () => {
        await init()
      })
    })

    return {
      ...toRefs(state),
      setLoading,
      clickBtn,
      init,
      clickStatusType,
      clickCard,
      clickDelete,
      onSearch,
      hiddenCard,
      beforeCloseDialog,
      showSubmitOrderPopUp,
      useDealerRef,
      viewUseDealer
    }
  }
}
